require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2005-12-28-mod-append-hostname.json") })
        }
      }, "path---articles-2005-12-28-mod-append-hostname");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2005-12-28-mod-append-hostname!./.cache/json/articles-2005-12-28-mod-append-hostname.json
// module id = 444
// module chunks = 231608221292675